namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_presets_page, {
		
		width: '18rem',
		flex: {
			grow: 0,
		},
		
	} )
	
}
